(function(algolia) {
  'use strict';

  var sort_order_base = algolia.config.index_prefix + 'products';

  /**
   * Turns one of Algolia's configured sort orders into a sortBy widget item.
   * The wording shown to shoppers is the title set against that sort order in
   * Shopify admin, under Algolia Search and Discovery > Collection Pages >
   * Sort Orders, so labels can be changed per store without a theme release.
   */
  function toSortOrderItem(sort_order, direction) {
    return {
      value: sort_order_base + '_' + sort_order.key + '_' + direction,
      label: sort_order[direction].title,
    };
  }

  function isActive(sort_order, direction) {
    return Boolean(
      sort_order[direction] &&
        (sort_order[direction].active === true ||
          sort_order[direction].active === '1')
    );
  }

  /**
   * Builds the sort menu from the sort orders enabled for this store, so each
   * region only offers the sorts it actually has pre-sorted lists for.
   */
  function buildSortOrders(sort_orders) {
    var items = [
      { value: sort_order_base, label: '' + algolia.translations.sortByPlaceholder },
    ];

    sort_orders.forEach(function(sort_order) {
      ['asc', 'desc'].forEach(function(direction) {
        if (isActive(sort_order, direction)) {
          items.push(toSortOrderItem(sort_order, direction));
        }
      });
    });

    return items;
  }

  algolia.sortOrders = buildSortOrders(algolia.config.sort_orders);

  // try to fetch sort orders for current collection or fallback to collections default
  var collection_sort_orders =
    algolia.current_collection_id &&
    algolia.config.collection_sort_orders &&
    algolia.config.collection_sort_orders[algolia.current_collection_id]
      ? algolia.config.collection_sort_orders[algolia.current_collection_id]
      : algolia.config.collection_sort_orders &&
        algolia.config.collection_sort_orders.default;

  if (collection_sort_orders) {
    algolia.collectionSortOrders = buildSortOrders(collection_sort_orders);
  }
})(window.algoliaShopify);
